import React, { useContext } from 'react'
import { useState, useEffect } from 'react'
import MyLocation from './MyLocation'
import { AppContext } from '../context/AppContext'
import {ReactComponent as BusIcon} from '../images/icon_bus.svg'
import {ReactComponent as TaxiIcon} from '../images/icon_taxi.svg'
import {ReactComponent as EvtolIcon} from '../images/icon_evtol.svg'

  
    const CommuteIcon = ({options}) => {
       if (options == 'commute-bus') {
             return <BusIcon />
       } else if (options == 'commute-taxi') {
        return <TaxiIcon />
        } else if (options == 'commute-evtol') {
            return <EvtolIcon />
        } else {
            return ""
        }
    }



const TripInfo = () => {

    
    const {tripDetails, infoShow, setInfoShow, closestAirports, commuteOptions} = useContext(AppContext)
    const [showPopUp, setShowPopUp] = useState(false);
    
    useEffect(() => {
        console.log("commuteIconFunction = " + commuteOptions)
       }, [commuteOptions]) 

    const togglePopUp = (e) => {
       let thisTarget = e.target.getAttribute("target")
       setShowPopUp(thisTarget)
       console.log(thisTarget)
    }

    const toggleInfoShow = () => {
        if (infoShow) {
            setInfoShow(false)
        } else {
            setInfoShow(true)
        }
    }

    return (
        <div id="trip-info" className={`trip-info` + (infoShow ? " show" : " hide")}>
            <button onClick={toggleInfoShow} className="button icon-button toggle-info">&#9662;</button>
            <div className="trip-info-wrap">
                <div className="destinations info-box">
                    <span className="destination-from"><h3>{tripDetails.location}</h3></span>
                    <span className="dash">–</span> 
                    <span className="destination-to"><h3>{tripDetails.destination}</h3></span>
                </div>
                <div className="airports info-box">
                    <span className="airports-from"><h4><CommuteIcon className="commute-from-icon" options={commuteOptions.from} />{closestAirports.from && `${closestAirports.from[0].name} (${closestAirports.from[0].abbreviation})`   }</h4></span>
                    <span className="dash">–</span> 
                    <span className="airports-to"><h4>{closestAirports.to && `${closestAirports.to[0].name} (${closestAirports.to[0].abbreviation})`}<CommuteIcon className="commute-from-icon" options={commuteOptions.to} /></h4></span>
                </div>
                <div className="trip-date-passengers info-box hide-me">
                    <span className="trip-date"><h4>{tripDetails.date}</h4></span>
                    <table clasName="trip-passengers">
                        {tripDetails.booker && 
                        <tr>
                            <td>Passenger 1 (Booker):</td><td><h4>{tripDetails.booker}</h4></td>
                        </tr>
                        }
                        {tripDetails.passengers &&
                            Object.keys(tripDetails.passengers).map(key =>
                                <tr>
                                    <td>Passenger {parseInt(key) + 1}:</td><td><h5>{tripDetails.passengers[key]}</h5></td>
                                </tr>
                            )
                        }
                      
                    </table>
                </div>
                <div className="time-info info-box">
                    <span className="departure-time info-grid hide-me">
                        <h4>Departure times</h4>
                        <span className="from">Earliest <i>{tripDetails.depFrom}</i></span>
                        <span className="to">Latest <i>{tripDetails.depTo}</i></span>
                    </span>
                    <span className="arrival-time info-grid hide-me">
                        <h4>Arrival times</h4>
                        <span className="from">Earliest <i>{tripDetails.arrFrom}</i></span>
                        <span className="to">Latest <i>{tripDetails.arrTo}</i></span>
                    </span>
                </div>
                <div className="price-info info-box">
                    {   tripDetails.priceFrom &&
                        <>
                        </>
                        
                    }
                    <span className="price info-grid">
                            <h4>Est. price / seat</h4>
                        <span className="price total"><i>{tripDetails.priceFrom} – {tripDetails.priceTo}  SEK</i></span>
                            <h5 className="hide-me">Flexible reduction</h5>
                        <span className="price price-reduction hide-me"><i>{tripDetails.priceFlexRed} SEK</i><button onClick={ togglePopUp } target="flex-popup" className="button button-what">?</button></span>
                            <h5 className="hide-me">Place fill reduction</h5>
                        <span className="price price-reduction hide-me"><i>{tripDetails.priceFillRed} SEK</i><button onClick={ togglePopUp } target="fill-popup"  className="button button-what">?</button></span>
                    </span>
                    <div id="flex-popup" className={showPopUp == "flex-popup" ? "pop-up explanation" : "pop-up explanation hide-me"}>
                        <div className="pop-up-content">
                            <h3>Flexible reduction</h3>
                            <p>This reduction reflects how flexible you have chosen to be. To get a higher flexible recution make sure that your <strong className="yellow">yellow time selector</strong> covers as much times as possible.</p>
                            <button onClick={togglePopUp} target="hide-popup" className="button close-button">Ok!</button>
                        </div>
                    </div>
                    <div id="fill-popup" className={showPopUp == "fill-popup" ? "pop-up explanation" : "pop-up explanation hide-me"}>
                        <div className="pop-up-content">
                            <h3>Place fill reduction</h3>
                            <p>This reduction reflects if you're booking will fill up any planes. The closer you are to filling a plane on any row in the time table. The reduction is based on your "best" row. Use the <strong className="yellow">the yellow time selector</strong> to choose your flexible time.</p>
                            <button onClick={togglePopUp} target="hide-popup" className="button close-button">Ok!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TripInfo;